import { CognitoAuth } from 'amazon-cognito-auth-js'

import LocalAuth from './LocalAuth'

export default process.env.NODE_ENV !== 'production' && process.env.REACT_APP_USE_DEV_ENV !== 'true'
  ? LocalAuth
  : CognitoAuth
